import styled from "styled-components";

import backgroundImg from '../../assets/img/4456.jpg';
import backgroundImgTablet from '../../assets/img/ide3.jpg';
import backgroundImgCel from '../../assets/img/8673.jpg';

export const Container = styled.section`
    width: 100%;
    height: 120vh;
    background: url(${backgroundImg}) no-repeat;
    background-size: cover;
    background-position: center;
    box-shadow: 0 0 10px 1px rgb(0 0 0 / 75%); 

    &::before {
        position: absolute;
        content: '';
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg,#292929 -2.19%,rgba(0,0,0,0) 59.97%)
    }
    
    /* div.date {
        width: 100%;
        height: 95vh;
        display: flex;
        justify-content: center;
        align-items: center;
    } */
    
    @media (max-width: 650px) {
        width: 100%;
        height: 100vh;
        background: url(${backgroundImgTablet}) no-repeat;
        background-size: cover;
        background-position: center;
    }
    /* @media (max-width: 550px) {
        width: 100%;
        height: 100vh;
        background: url(${backgroundImgCel}) no-repeat;
        background-size: cover;
        background-position: center;
    } */
`

export const HeaderContainer = styled.header`
    color: var(--white);
    padding: 60px 0 30px;
    position: relative;

    div {
        display: flex;
        justify-content: center;

        a {
            font-family: 'Great Vibes', sans-serif;
            text-decoration: none;
            font-size: 2rem;      
            color: var(--white);      
        }
    }

    nav {
        display: flex;
        justify-content: center;
        max-width: 1024px;
        margin: 25px auto 0;

        ul {
            display: flex;
            justify-content: center;
            width: 100%;
            font-family: 'Josefin Slab', sans-serif;
            font-weight: 600;
            text-transform: uppercase;
            font-size: 14px;
            letter-spacing: 0.04rem;
            flex-wrap: wrap;
            margin: 0 30px;

            li {
                cursor: pointer;
                transition: 0.3s;
                margin: 5px 10px;

                &:hover {
                    color: var(--rose);
                }
            }
        }
    }

`